export default __webpack_public_path__ + "static/media/section02.72f04899.jpg";